import {
  Modal,
  Stack,
  Typography,
  TextField,
  Container,
  ListItem,
  Box,
  Chip,
  useTheme,
  Card,
  useMediaQuery,
  Button,
  IconButton,
  Divider,
  ListItemButton,
  ListItemText
} from "@mui/material";
import { BIBlue } from "../../assets/helpers";
import BuildIcon from "@mui/icons-material/Build";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import { useSelector } from "react-redux";
import { English } from "../../constant/EnglishFallback";
import { ArrowUpwardRounded } from "@mui/icons-material";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";

const ContentSearchTutorial = (props) => {
  const { multiLanguageData } = useSelector((state) => state?.main);
  const LanguageData = multiLanguageData?.GlobalSearch || {};
  const {
    TEXT_TYPE = English.GlobalSearch.TEXT_TYPE,
    TEXT_COMPANIES = English.GlobalSearch.TEXT_COMPANIES,
    TEXT_MANUFACTURERS = English.GlobalSearch.TEXT_MANUFACTURERS,
    TEXT_PRODUCTS = English.GlobalSearch.TEXT_PRODUCTS,
    TEXT_TRADES = English.GlobalSearch.TEXT_TRADES,
    TEXT_ADVANCED = English.GlobalSearch.TEXT_ADVANCED,
    TEXT_LOCATION_TYPE_HERE_PLACEHOLDER = English.GlobalSearch.TEXT_LOCATION_TYPE_HERE_PLACEHOLDER,
    TEXT_QUICK_LOCATION = English.GlobalSearch.TEXT_QUICK_LOCATION,
    TEXT_SHOW_MORE_TRADES = English.GlobalSearch.TEXT_SHOW_MORE_TRADES,
    TEXT_TUTORIAL_FIFTH = English.GlobalSearch.TEXT_TUTORIAL_FIFTH,
    TEXT_TUTORIAL_SIXTH = English.GlobalSearch.TEXT_TUTORIAL_SIXTH,
    TEXT_UNIVERSAL_SEARCH = English.GlobalSearch.TEXT_UNIVERSAL_SEARCH,
    TEXT_TUTORIAL_FIRST = English.GlobalSearch.TEXT_TUTORIAL_FIRST,
    TEXT_TUTORIAL_SECOND = English.GlobalSearch.TEXT_TUTORIAL_SECOND,
    TEXT_TAP_ANYWHERE_TO_CONTINUE = English.GlobalSearch.TEXT_TAP_ANYWHERE_TO_CONTINUE,
    TEXT_TUTORIAL_THIRD = English.GlobalSearch.TEXT_TUTORIAL_THIRD,
    TEXT_TUTORIAL_FORTH = English.GlobalSearch.TEXT_TUTORIAL_FORTH
  } = LanguageData || {};

  const theme = useTheme();
  const drawerWidth = 240;
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const typeList = [
    { text: TEXT_COMPANIES, checked: false, itemRecordType: "company" },
    { text: TEXT_MANUFACTURERS, checked: false, itemRecordType: "manufacturer" },
    { text: TEXT_PRODUCTS, checked: false, itemRecordType: "product" },
    { text: TEXT_TRADES, checked: false, itemRecordType: "trade" }
  ];

  const tradeList = [
    {
      id: 1,
      name: "Boilermaker "
    },
    {
      id: 2,
      name: "Bricklayer "
    },
    {
      id: 3,
      name: "Cabinetmaker"
    },
    {
      id: 4,
      name: "Carpenter"
    },
    {
      id: 5,
      name: "Concrete Finisher"
    },
    {
      id: 6,
      name: "Construction Craft Worker"
    },
    {
      id: 7,
      name: "Cladder"
    },
    {
      id: 8,
      name: "Crane and Hoisting Equipment Operator"
    },
    {
      id: 9,
      name: "Electrician"
    },
    {
      id: 10,
      name: "Elevator Constructor"
    },
    {
      id: 11,
      name: "Floorcovering Installer"
    },
    {
      id: 12,
      name: "Gas Utility Operator"
    }
  ];

  return (
    <Modal open={props?.tutorialIndex === 0 ? false : true}>
      <Box sx={{ backgroundColor: "rgba(0, 0, 0, 0.7)", height: "100%" }} onClick={props.onPress}>
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            height: `calc(100vh - ${theme.mixins.toolbar.minHeight}px)`, // Dynamically set height
            overflowY: "auto",
            mt: `${theme.mixins.toolbar.minHeight}px`, // Push content below AppBar
            width: { sm: props.tutorialIndex === 1 ? "100%" : `calc(100% - ${drawerWidth}px)` }, // Ensure content doesn't go behind Sidebar
            marginLeft: { sm: props.tutorialIndex === 1 ? 0 : `${drawerWidth}px`, xs: 0 }
          }}>
          <Box className="main-content-Box" sx={{ p: isSmallScreen ? 2 : 3 }}>
            {props.tutorialIndex === 1 && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100vh"
                }}>
                <Stack sx={{ textAlign: "center", color: "white" }}>
                  <Typography variant="h6">{TEXT_UNIVERSAL_SEARCH}</Typography>
                  <Typography variant="subtitle1">{TEXT_TUTORIAL_FIRST}</Typography>
                  <Typography variant="subtitle1">{TEXT_TUTORIAL_SECOND}</Typography>
                  <Typography variant="body1">
                    <span style={{ color: BIBlue }}> ({TEXT_TAP_ANYWHERE_TO_CONTINUE})</span>
                  </Typography>
                </Stack>
              </Box>
            )}

            <Card
              className="main-content-card"
              sx={{
                backgroundColor: "transparent !important",
                border: "none",
                mt: 0,
                display: props.tutorialIndex === 2 || props.tutorialIndex === 3 ? "block" : "none"
              }}>
              <Box className="main-content-card-list">
                <Container sx={{ padding: 0.1 }} maxWidth="md">
                  <Stack spacing={1.5} mb={0.5}>
                    <Typography>{TEXT_TYPE}</Typography>
                    <Stack spacing={1.5} direction={"row"}>
                      {typeList.map((item, index) => {
                        return (
                          <Button
                            size="large"
                            key={index}
                            label={item?.forTranlate}
                            variant={props.tutorialIndex === 2 ? "contained" : "text"}
                            disabled={props.tutorialIndex === 2 ? false : true}
                            sx={{
                              alignItems: "center",
                              border: props.tutorialIndex === 2 && "1px solid rgb(216 216 216)",
                              boxShadow: "none",
                              textTransform: "none",
                              p: "11px 20px",
                              width: "100%",
                              color: BIBlue,
                              backgroundColor: props.tutorialIndex === 2 && "white"
                            }}
                            startIcon={
                              item.itemRecordType === "product" ||
                              item.itemRecordType === "trade" ? (
                                <BuildIcon sx={{ color: props.tutorialIndex === 2 && BIBlue }} />
                              ) : (
                                <BusinessCenterIcon
                                  sx={{ color: props.tutorialIndex === 2 && BIBlue }}
                                />
                              )
                            }>
                            {" "}
                            {item?.text}{" "}
                          </Button>
                        );
                      })}
                    </Stack>
                    {props.tutorialIndex === 2 ? (
                      <Stack display={"flex"} textAlign={"center"} alignItems={"center"} m={0.5}>
                        <IconButton disabled>
                          <ArrowUpwardRounded style={{ fontSize: "30px", color: "white" }} />
                        </IconButton>
                        <Typography color="white"> {TEXT_TUTORIAL_THIRD}</Typography>
                        <Typography color="white"> {TEXT_TUTORIAL_FORTH}</Typography>
                      </Stack>
                    ) : (
                      <>
                        <Card className="pagelist-content" sx={{ marginTop: "0px" }}>
                          <ListItem
                            sx={{ m: 0 }}
                            disablePadding
                            secondaryAction={
                              <Stack direction={"row"} spacing={1} alignItems={"center"}>
                                <IconButton disabled>
                                  <ArrowDropUpIcon />
                                </IconButton>
                              </Stack>
                            }>
                            <ListItemButton>
                              <ListItemText primary={TEXT_ADVANCED} />
                            </ListItemButton>
                          </ListItem>

                          <Stack spacing={1.5} p={2} pt={{ xs: 0, sm: 1 }}>
                            <TextField
                              variant="outlined"
                              placeholder={TEXT_LOCATION_TYPE_HERE_PLACEHOLDER}
                              size="small"
                              fullWidth
                              value={""}
                              disabled
                            />
                            <Stack>{TEXT_QUICK_LOCATION}</Stack>
                            <Stack
                              sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}
                              direction="row">
                              <Chip size="medium" label={"Calgary"} />
                            </Stack>
                            <Divider />
                            <Stack
                              sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}
                              direction="row">
                              {tradeList?.slice(0, 10)?.map((item, index) => {
                                return (
                                  <Chip
                                    size="medium"
                                    key={index}
                                    label={
                                      item.name.length > 30 ? item.name?.trim() : item.name?.trim()
                                    }
                                  />
                                );
                              })}
                              <Button style={{ borderRadius: "50px" }} size="small" variant="text">
                                {TEXT_SHOW_MORE_TRADES}
                              </Button>
                            </Stack>
                          </Stack>
                        </Card>
                        <Stack display={"flex"} textAlign={"center"} alignItems={"center"} m={0.5}>
                          <IconButton disabled>
                            <ArrowUpwardRounded style={{ fontSize: "30px", color: "white" }} />
                          </IconButton>
                          <Typography color="white"> {TEXT_TUTORIAL_FIFTH}</Typography>
                          <Typography color="white"> {TEXT_TUTORIAL_SIXTH}</Typography>
                        </Stack>
                      </>
                    )}
                  </Stack>
                </Container>
              </Box>
            </Card>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default ContentSearchTutorial;
